// /src/pages/ErrorPage.js
import React from 'react';
import { Box, Heading, Text, Button, VStack } from '@chakra-ui/react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { WarningIcon } from '@chakra-ui/icons';

const ErrorPage = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const message = searchParams.get('message');

    const getErrorContent = () => {
        switch (message) {
            case 'invalid-uuid':
                return {
                    title: 'Invalid Access Link',
                    description: 'The link you used is not valid. Please check your link and try again.',
                };
            case 'invalid-access':
                return {
                    title: 'Direct Access Not Allowed',
                    description: 'Please use the unique link provided to access this service.',
                };
            default:
                return {
                    title: 'Something Went Wrong',
                    description: 'An unexpected error occurred. Please try again later.',
                };
        }
    };

    const { title, description } = getErrorContent();

    return (
        <Box 
            minH="100vh" 
            display="flex" 
            alignItems="center" 
            justifyContent="center"
            bg="gray.50"
            px={4}
        >
            <VStack 
                spacing={6} 
                bg="white" 
                p={8} 
                borderRadius="lg" 
                boxShadow="lg"
                maxW="500px"
                textAlign="center"
            >
                <WarningIcon boxSize={16} color="red.500" />
                <Heading size="lg" color="gray.700">
                    {title}
                </Heading>
                <Text color="gray.600" fontSize="lg">
                    {description}
                </Text>
                <Button 
                    colorScheme="blue" 
                    size="lg"
                    onClick={() => navigate('/')}
                    mt={4}
                >
                    Go to Home
                </Button>
            </VStack>
        </Box>
    );
};

export default ErrorPage;